import { AlertPopup } from './AlertPopup';
import { EventPopup } from './EventPopup';
import { ExternalPersonPopup } from './ExternalPersonPopup';
import { ExternalVehiclePopup } from './ExternalVehiclePopup';
import { IncidentPopup } from './IncidentPopup';
import { LocationPopup } from './LocationPopup';
import { ObjectivePopup } from './ObjectivePopup';
import { PersonPopup } from './PersonPopup';
import { VehiclePopup } from './VehiclePopup';

export function Popup({ hoverInfo }) {
  switch (hoverInfo.feature.source) {
    case 'vehicles':
      return <VehiclePopup hoverInfo={hoverInfo} />;
    case 'people':
      return <PersonPopup hoverInfo={hoverInfo} />;
    case 'locations':
      return <LocationPopup hoverInfo={hoverInfo} />;
    case 'incidents':
      return <IncidentPopup hoverInfo={hoverInfo} />;
    case 'events':
      switch (hoverInfo.feature?.properties?.eventType) {
        case 'ACCELEROMETERALERT':
          return <AlertPopup hoverInfo={hoverInfo} />;
        case 'ACCELEROMETEREVENT':
          return <EventPopup hoverInfo={hoverInfo} />;
        default:
          return null;
      }
    case 'objectives':
      return <ObjectivePopup hoverInfo={hoverInfo} />;
    case 'externalVehicles':
      return <ExternalVehiclePopup hoverInfo={hoverInfo} />;
    case 'externalPeople':
      return <ExternalPersonPopup hoverInfo={hoverInfo} />;
    default:
      return null;
  }
}
